export const appStoreLink = "https://apps.apple.com/us/app/frostfall/id1417448796?ls=1"
export const playStoreLink = "https://play.google.com/store/apps/details?id=com.dusk.frostfall"
export const duskGamesLink = "javascript:;"